import React, { useEffect, useState } from "react";
import Notification from "../Homepage/components/Notifications";

export default function MobileHeader() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDropdown = (event, level) => {
    if (isMobile) {
      event.preventDefault();
      const currentTarget = event.currentTarget;
      const submenu = currentTarget.nextElementSibling;

      if (submenu) {
        const isCurrentlyActive = submenu.classList.contains("show");

        // Close all other open dropdowns at the same level
        const allDropdowns = document.querySelectorAll(
          `.dropdown-menu.show.level-${level}`
        );
        allDropdowns.forEach((dropdown) => {
          if (dropdown !== submenu) {
            dropdown.classList.remove("show");
          }
        });

        // Toggle the clicked dropdown
        submenu.classList.toggle("show");

        // If this dropdown was just opened, close any open child dropdowns
        if (!isCurrentlyActive) {
          const childDropdowns = submenu.querySelectorAll(
            ".dropdown-menu.show"
          );
          childDropdowns.forEach((childDropdown) => {
            childDropdown.classList.remove("show");
          });
        }
      }
    }
  };

  return (
    <header className="fixed-top header">
      <Notification />
      <div
        className="py-2 bg-white"
        style={{
          minHeight: "15px",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <div className="container">
          <div className="col-lg-4 text-center text-lg-left">
            <a className="text-color mr-3" href="tel:+9101202401442">
              <strong>CALL</strong> +91-0120-2401442
            </a>
            <ul className="list-inline d-inline">
              <li className="list-inline-item mx-0">
                <a
                  className="d-inline-block p-2 text-color"
                  target="_blank"
                  href="https://www.facebook.com/profile.php?id=61562471954848"
                >
                  <i className="ti-facebook"></i>
                </a>
              </li>
              <li className="list-inline-item mx-0">
                <a
                  target="_blank"
                  className="d-inline-block p-2 text-color"
                  href="https://x.com/JssUniNoida"
                >
                  <i className="ti-twitter-alt"></i>
                </a>
              </li>
              <li className="list-inline-item mx-0">
                <a
                  target="_blank"
                  className="d-inline-block p-2 text-color"
                  href="https://www.linkedin.com/company/jss-university-noida/"
                >
                  <i className="ti-linkedin"></i>
                </a>
              </li>
              <li className="list-inline-item mx-0">
                <a
                  target="_blank"
                  className="d-inline-block p-2 text-color"
                  href="https://www.instagram.com/jssuniversitynoida?igsh=MWplNm0ycmo2M3A2cg=="
                >
                  <i className="ti-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a
              className="btn btn-primary"
              style={{
                padding: "5px 10px",
                marginLeft: "10px",
                backgroundColor: "crimson",
                fontSize: "0.8em",
              }}
              href="https://jssuninoida.edu.in/assets/docs/merit-3.pdf"
              target="_blank"
            >
              Admission 2025 - Merit List Announced
            </a>
          </div>
          <div
            style={{
              marginLeft: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <a
              className="btn btn-primary"
              style={{
                padding: "5px 10px",
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: "crimson",
                fontSize: "0.6em",
              }}
              href="https://www.ugc.gov.in/"
              target="_blank"
            >
              UGC
            </a>
            <a
              className="btn btn-primary"
              style={{
                padding: "5px 10px",
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: "crimson",
                fontSize: "0.6em",
              }}
              href="https://onlinecourses.nptel.ac.in/"
              target="_blank"
            >
              NPTEL
            </a>

            <a
              className="btn btn-primary"
              style={{
                padding: "5px 10px",
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: "crimson",
                fontSize: "0.6em",
              }}
              href="https://swayam.gov.in/"
              target="_blank"
            >
              SWAYAM
            </a>

            <a
              className="btn btn-primary"
              style={{
                padding: "5px 10px",
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: "crimson",
                fontSize: "0.6em",
              }}
              href="https://studyinindia.gov.in/"
              target="_blank"
            >
              Study in India
            </a>
            <a
              className="btn btn-primary"
              style={{
                padding: "5px 10px",
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: "crimson",
                fontSize: "0.6em",
              }}
              href="https://samadhaan.ugc.ac.in"
              target="_blank"
            >
              E-Samadhan
            </a>
          </div>
        </div>
      </div>
      <div
        className="navigation w-100"
        style={{ marginTop: "-46px !important" }}
      >
        <nav className="navbar navbar-expand-lg navbar-light p-0">
          <a
            style={{
              maxWidth: "30%",
              color: "#fff",
              fontWeight: "bolder",
              padding: "5px 30px",
            }}
            href="/"
            className="navbar-brand"
          >
            <img
              src="./images/logo.png"
              alt="logo"
              style={{
                maxHeight: "60px",
                maxWidth: "60px",
                margin: "0px 15px",
              }}
            />
            <div
              style={{
                textAlign: "center",
                display: "inline-block",
                lineHeight: "1em",
                verticalAlign: "middle",
              }}
            >
              JSS
              <br />
              UNIVERSITY
            </div>
          </a>
          <button
            className="navbar-toggler rounded-0"
            type="button"
            data-toggle="collapse"
            data-target="#navigation"
            aria-controls="navigation"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navigation">
            <ul className="navbar-nav mr-auto text-center">
              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  About
                </a>
                <ul
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      About Us
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a className="dropdown-item" href="/about-jssmvp">
                          About JSSMVP
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/about-university">
                          About JSS University
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/statutory-bodies">
                      Act and Statutes or MoA
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/development">
                      Institutional Development Plan
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Constituent Units
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Accreditation
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/statutory-bodies">
                      Recognition
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      target="_blank"
                      href="https://jssuninoida.edu.in/assets/docs/Annual_Report_20250519.pdf"
                    >
                      Annual Reports
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Annual Account
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Committees &raquo;
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => toggleDropdown(e, 3)}
                        >
                          Statutory &raquo;
                        </a>
                        <ul className="submenu dropdown-menu level-3">
                          <li>
                            <a
                              className="dropdown-item"
                              href="/governing-bodies"
                            >
                              Governing Body (GB)
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/executive-council"
                            >
                              Executive Council (EC)
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://jssuninoida.edu.in/assets/docs/Academic_Council_Latest.pdf"
                              target="_blank"
                            >
                              Academic Council
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://jssuninoida.edu.in/assets/docs/BOS.pdf"
                              target="_blank"
                            >
                              Board of Studies (BoS)
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/iqac">
                          Non Statutory
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  Administration
                </a>
                <ul
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <a className="dropdown-item" href="/chancellor">
                      Chancellor
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/about-pro-chancellor">
                      Pro Chancellor
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/administration-vice-chancellor"
                    >
                      Vice Chancellor
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Pro-Vice-Chancellor
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/registrar-message">
                      Registrar
                    </a>
                  </li>

                  <li>
                    <a className="dropdown-item" href="/finance-officer">
                      Financial Officer
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/controller-of-examination"
                    >
                      Controller of Examination (CoE)
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Chief Vigilance Officer
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Ombudsperson
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Academic Leadership
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a className="dropdown-item" href="/dean-eng">
                          Dean Engineering and Technology
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/dean-student">
                          Dean Student Welfare
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/dean-research">
                          Dean Research
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/dean-edge">
                          Dean EDGE
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/dean-bqs">
                          Dean BQS
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <a className="dropdown-item" href="#">
                      Internal Complaint Committee
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  Academics
                </a>
                <ul
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Details of Academic Programs
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a
                          className="dropdown-item"
                          href="/school-of-engineering"
                        >
                          Under Graduate Program
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/school-of-management"
                        >
                          Post Graduate Program
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/calendar-of-events">
                      Academic Calendar
                    </a>
                  </li>
                  <li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={(e) => toggleDropdown(e, 2)}
                      >
                        Statutes »
                      </a>
                      <ul class="submenu dropdown-menu level-2">
                        <li>
                          <a
                            className="dropdown-item"
                            target="_blank"
                            href="https://jssuninoida.edu.in/assets/docs/regulation_btech.pdf"
                          >
                            B.TECH
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            target="_blank"
                            href="https://jssuninoida.edu.in/assets/docs/regulation_mca.pdf"
                          >
                            MCA
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            target="_blank"
                            href="https://jssuninoida.edu.in/assets/docs/regulation_mpharma.pdf"
                          >
                            M.PHARM
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            target="_blank"
                            href="https://jssuninoida.edu.in/assets/docs/Rev_00_JSS_University_Noida_D.Pharma_Examination_regulations.pdf"
                          >
                            D.PHARM
                          </a>
                        </li>
                      </ul>
                    </li>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Schools &raquo;
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a
                          className="dropdown-item"
                          href="/school-of-engineering"
                        >
                          School Of Engineering
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/school-of-pharmacy">
                          School Of Pharmacy
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/school-of-management"
                        >
                          School Of Management
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          School Of Computer Applications
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/school-of-applied-sciences"
                        >
                          School Of Applied Sciences
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/school-of-humanities"
                        >
                          School Of Humanities
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/iqac">
                      Internal Quality Assurance Cell (IQAC)
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/library-information-centre"
                    >
                      Library
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Academic collaboration
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Faculty &raquo;
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a
                          className="dropdown-item"
                          href="/faculty-of-engg-tech"
                        >
                          Faculty of Engineering & Technology
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/faculty-of-science">
                          Faculty of Science
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/faculty-of-humanities"
                        >
                          Faculty of Humanities
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/page-under-development"
                        >
                          Faculty of Management Studies
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://jssaten.ac.in/pview/pharmacy"
                        >
                          Faculty of Pharmacy
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Syllabus & Schemes &raquo;
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a
                          className="dropdown-item"
                          target="_blank"
                          href="https://jssuninoida.edu.in/assets/docs/B.TECH_SYLLABUS_JSS_UNIVERSITY_2025.pdf"
                        >
                          B.Tech Syllabus & Schemes
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          target="_blank"
                          href="https://jssuninoida.edu.in/assets/docs/MCA_SYLLABUS_JSS_UNIVERSITY_2025.pdf"
                        >
                          MCA Syllabus & Schemes
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          target="_blank"
                          href="https://jssuninoida.edu.in/assets/docs/JSS_University_Noida_B.Pharm_Scheme_&_Syllabus.pdf"
                        >
                          B.Pharma Syllabus & Schemes
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          target="_blank"
                          href="https://jssuninoida.edu.in/assets/docs/JSS_University_Noida_D.Pharma_Scheme_&_Syllabus.pdf"
                        >
                          D.Pharma Syllabus & Schemes
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          target="_blank"
                          href="https://jssuninoida.edu.in/assets/docs/JSS_University_Noida_M.Pharma_Scheme_&_Syllabus.pdf"
                        >
                          M.Pharma Syllabus & Schemes
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          target="_blank"
                          href="https://jssuninoida.edu.in/assets/docs/phd-syllabus.pdf"
                        >
                          Ph.D Syllabus & Schemes
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/page-under-development">
                      Exam Schedule
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://jssuninoida.edu.in/assets/docs/TIME_TABLE.pdf"
                      target="_blank"
                    >
                      Time Table
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Professional Bodies &raquo;
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a className="dropdown-item" href="/csi-detail">
                          CSI
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/sae-detail">
                          SAE
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/iete-detail">
                          IETE
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/iste-detail">
                          ISTE
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/ieee-detail">
                          IEEE
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Industry Collaboration & MoUs
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/university-news-letter">
                      University News Letter
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  Admission
                </a>
                <ul
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <a
                      className="dropdown-item"
                      target="_blank"
                      href="https://jssuninoida.edu.in/assets/docs/brochure.pdf"
                    >
                      Prospectus
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/admission-main">
                      Admission Process and Guidelines
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Fee refund policy
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/admission-helpdesk-contact"
                    >
                      Admission Help Desk & Contact Details
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  Examination
                </a>
                <ul className="dropdown-menu level-1">
                  <li>
                    <a className="dropdown-item" href="/examination-circulars">
                      Circular and Examination Schedule
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://studentportal.universitysolutions.in/index.html"
                    >
                      Examination Fee
                    </a>
                  </li>
                  <li className="dropdown-submenu">
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Examination Regulations
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li className="dropdown-submenu">
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => toggleDropdown(e, 3)}
                        >
                          School of Engineering
                        </a>
                        <ul className="submenu dropdown-menu level-3">
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://jssuninoida.edu.in/assets/docs/regulation_btech.pdf"
                            >
                              B.Tech
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown-submenu">
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => toggleDropdown(e, 3)}
                        >
                          School of Pharmacy
                        </a>
                        <ul className="submenu dropdown-menu level-3">
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://jssuninoida.edu.in/assets/docs/Rev_02_JSS_University_Noida_B.Pharma_Examination_regulations.pdf"
                            >
                              B.Pharm
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://jssuninoida.edu.in/assets/docs/Rev_00_JSS_University_Noida_D.Pharma_Examination_regulations.pdf"
                            >
                              D.Pharm
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://jssuninoida.edu.in/assets/docs/regulation_mpharma.pdf"
                            >
                              M.Pharm
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown-submenu">
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => toggleDropdown(e, 3)}
                        >
                          School of Computer Applications
                        </a>
                        <ul className="submenu dropdown-menu level-3">
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://jssuninoida.edu.in/assets/docs/Rev_01_JSS_University_Noida_MCA_Examination_regulations.pdf"
                            >
                              MCA
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          target="_blank"
                          href="https://jssuninoida.edu.in/assets/docs/PhD_REGULATIONS.pdf"
                        >
                          PH.D
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/ABCId">
                      NAD, APAAR ID, & ABC ID
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/page-under-development">
                      PH.D Results
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/phd-exam-notifications">
                      PHD Exam Notifications
                    </a>
                  </li>
                  <li className="dropdown-submenu">
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => toggleDropdown(e, 2)}
                    >
                      Results &raquo;
                    </a>
                    <ul className="submenu dropdown-menu level-2">
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://studentportal.universitysolutions.in/index.html"
                        >
                          Result
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://jssuninoida.edu.in/assets/docs/EXAM_GRIVENCE_FORM.docx"
                          target="_blank"
                        >
                          Examination Grievance Form
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/page-under-development">
                      Examination manual
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/question-papers">
                      Question Papers
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/page-under-development">
                      Convocation
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://college.universitysolutions.in/jssun/"
                    >
                      Utilities
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/contact-us">
                      Contact us
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  Research & Innovation
                </a>
                <ul
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <a
                      className="dropdown-item"
                      target="_blank"
                      href="https://jssuninoida.edu.in/assets/docs/rnd-new.pdf"
                    >
                      Research and Development Cell
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/step-info">
                      Incubation Centre and Startups in Campus
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Central Facilities
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://jssuninoida.edu.in/assets/docs/PhD_Admission_Notification.pdf"
                      target="_blank"
                    >
                      PhD Admission Notification
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://jssuninoida.edu.in/assets/docs/PhD_REGULATIONS.pdf"
                      target="_blank"
                    >
                      PhD Regulation
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://jssuninoida.edu.in/assets/docs/phd-guide.pdf"
                      target="_blank"
                    >
                      PhD Guide List
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://jssuninoida.edu.in/assets/docs/Phd_Research_Form_3.pdf"
                      target="_blank"
                    >
                      Form for Guide/Co-Guide (Form-3)
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://jssuninoida.edu.in/assets/docs/PhD_Research_Form_1.pdf"
                      target="_blank"
                    >
                      Form for Admission to PhD Program (Form-1)
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/research-facilities">
                      Research Centres and Facilities
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  Student Life
                </a>
                <div
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <a className="dropdown-item" href="/sports-facilities">
                    Sports
                  </a>
                  <a className="dropdown-item" href="/hostel-facilities">
                    Hostel Details
                  </a>
                  <a className="dropdown-item" href="/placement-statistics">
                    Placement Cell
                  </a>
                  <a
                    className="dropdown-item"
                    target="_blank"
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdqHNGC_-cTL4NV3t-X9XXgS3ge8ZPdkW2geI6VEoXEZunmDw/viewform"
                  >
                    Details of Student Grievance Redressal Committee
                  </a>
                  <a className="dropdown-item" href="/medical-facilities">
                    Health Facilities
                  </a>
                  <a className="dropdown-item" href="#">
                    Internal Complaint Committee
                  </a>
                  <a
                    className="dropdown-item"
                    target="_blank"
                    href="https://jssuninoida.edu.in/assets/docs/ant_ragging_committe.pdf"
                  >
                    Anti-Ragging Cell
                  </a>
                  <a className="dropdown-item" href="#">
                    Equal Opportunity Committee
                  </a>
                  <a className="dropdown-item" href="#">
                    Socio-Economically Disadvantaged Groups Cell (SEDG)
                  </a>

                  <a
                    className="dropdown-item"
                    target="_blank"
                    href="https://jssuninoida.edu.in/assets/docs/facility-different-abled_20250519.pdf"
                  >
                    Facilities for differently-abled
                  </a>
                  <a className="dropdown-item" href="/scholarships">
                    Scholarships
                  </a>
                  <a className="dropdown-item" href="/mentoring">
                    Mentoring Scheme
                  </a>
                </div>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  Information Corner
                </a>
                <ul
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <a className="dropdown-item" href="/#">
                      RTI
                    </a>
                    <a className="dropdown-item" href="/examination-circulars">
                      Circulars and Notices
                    </a>
                    <a className="dropdown-item" href="#">
                      Announcements
                    </a>
                    <a className="dropdown-item" href="/university-news-letter">
                      Newsletters
                    </a>
                    <a className="dropdown-item" href="#">
                      News, Recent events & Achievements
                    </a>
                    <a className="dropdown-item" href="/career">
                      Job openings
                    </a>
                    <a className="dropdown-item" href="#">
                      Study in India
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  Alumini
                </a>
                <ul
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <a className="dropdown-item" href="/alumini">
                      Alumni Association with details
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item view">
                <a className="nav-link" href="/mandatory-disclosures">
                  Mandatory Disclosures
                </a>
              </li>

              <li className="nav-item dropdown view">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  onClick={(e) => toggleDropdown(e, 1)}
                >
                  More
                </a>
                <ul
                  className="dropdown-menu level-1"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <a className="dropdown-item" href="/iqac">
                      IQAC
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/photo-gallery">
                      Photo Gallery
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://forms.gle/dsApqfUTFfht5G7R7"
                      target="_blank"
                    >
                      Online Grievance
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/media-coverage">
                      Media Coverage
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/career">
                      Career Oppurtunity
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/ads-archive">
                      Ads Archives
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item view">
                <a className="nav-link" href="/placement-statistics">
                  Training & Placement Activities
                </a>
              </li>

              <li className="nav-item view">
                <a className="nav-link" href="/contact-us">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
}
